import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Wrapper component that applies demonstrations theme class to children
 * when the pathname starts with /dems
 */
export const DemonstrationsThemeWrapper = ({ children }) => {
  const location = useLocation();
  const isDemonstrations = location.pathname.startsWith('/dems');
  
  return (
    <div className={isDemonstrations ? 'demonstrations-theme' : ''}>
      {children}
    </div>
  );
};

export default DemonstrationsThemeWrapper;
